import { Image, StyleSheet, View } from 'react-native';
import React from 'react';
import Input from '../common/Input';
import { ActivityIndicator } from 'react-native';

const SearchBar = ({ onQuery, isQuerying, onBlur, onFocus, onSubmit }) => {
    return (
        <View style={{ flex: 1, alignItems: 'center' }}>
            <Input
                autoFocus={true}
                onBlur={onBlur}
                onFocus={onFocus}
                onChange={onQuery}
                onKeyPress={onSubmit}
                containerstyle={[styles.inputContainer]}
                placeholder="Customer Search By Name & Address Only"
                clear
                required
                labelNumber={4}
                leftIcon={
                    <View style={{ paddingLeft: 14 }}>
                        <Image
                            source={require('../../../assets/search.png')}
                            style={styles.img}
                        />
                    </View>
                }
            />
            {isQuerying && <ActivityIndicator />}
        </View>
    );
};

const styles = StyleSheet.create({
    inputContainer: {
        marginLeft: 0,
        borderWidth: 2,
        minWidth: 700,
        borderRadius: 20,
        flex: 1,
        borderBottomWidth: 2,
        borderBottomLeftRadius: 20,
        borderBottomRightRadius: 20,
    },
    noBorders: {
        borderBottomWidth: 0,
        borderBottomLeftRadius: 0,
        borderBottomRightRadius: 0,
    },
    img: {
        width: 20,
        height: 20,
    },
});

export default SearchBar;
